<template>
  <div class="col-12 mt-4">
    <b-table
      :items="items"
      :fields="fields"
      :hover="hover"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :per-page="per_page_table"
      :current-page="currentPage"
      @row-selected="onRowSelected"
      :select-mode="select_mode"
      :selectable="selectable"
      :show-empty="show_empty"
      :label-sort-asc="label_sort_asc"
      :label-sort-desc="label_sort_desc"
      :label-sort-clear="label_sort_clear"
      :sort-icon-right="sort_icon_right"
      :no-border-collapse="no_border_collapse"
      :responsive="responsive"
      :thead-class="thead_class"
      :tbody-class="tbody_class"
      :ref="ref"
      :info="info"
      :class="class_table"
    >
      <template #empty> {{ $t('empty-row') }} </template>
      <v-slot></v-slot>
      <slot></slot>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="total_rows"
      :per-page="per_page_pagination"
      :first-number="first_number"
      :last-number="last_number"
      :aria-controls="aria_controls"
      :class="class_pagination"
    ></b-pagination>
  </div>
</template>

<script>
export default {
  props: [
    'items',
    'fields',
    'hover',
    'per_page_table',
    'sortBy',
    'sortDesc',
    'currentPage',
    'select_mode',
    'selectable',
    'show_empty',
    'label_sort_asc',
    'label_sort_desc',
    'label_sort_clear',
    'sort_icon_right',
    'no_border_collapse',
    'responsive',
    'thead_class',
    'tbody_class',
    'class_table',
    'ref',
    'info',
    'rows',
    'first_number',
    'last_number',
    'aria_controls',
    'class_pagination',
    'total_rows',
    'per_page_pagination',
    'total_rows',
  ],
}
</script>

<style lang="scss">
.custom-table {
  .table.b-table {
    thead {
      font-weight: 700 !important;
      font-size: 12px !important;
      line-height: 24px;
      letter-spacing: -0.006em;
      color: var(--color-02);
      th {
        border: none;
      }
      tr {
        [aria-sort] {
          background-size: 17px !important;
        }
        [aria-sort='none'],
        [aria-sort='descending'],
        [aria-sort='ascending'] {
          background-size: 1.65em 1em;
        }
        [aria-sort='none'],
        [aria-sort='descending'] {
          background-image: url('@/assets/images/icons/sort-descending.svg') !important;
        }
        [aria-sort='ascending'] {
          background-image: url('@/assets/images/icons/sort-ascending.svg') !important;
        }
        [aria-sort]:not(.b-table-sort-icon-left) {
          background-position: right calc(-0.25rem / 2) center !important;
          padding-right: calc(0.75rem + -0.35em);
        }
        .driver-tdClass {
          width: 170px;
        }
      }
    }
    tbody {
      tr {
        background-color: var(--color-01);
        td {
          height: 70px;
          border-block: 1px solid var(--color-15);
          padding-block: 18px;
          font-weight: 700;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.25px;
          color: var(--color-17);
        }
        td:first-child {
          border-end-start-radius: 4px;
          border-start-start-radius: 4px;
          border-inline-start: 1px solid var(--color-15);
        }
        td:last-child {
          border-start-end-radius: 4px;
          border-end-end-radius: 4px;
          border-inline-end: 1px solid var(--color-15);
        }
      }
    }
  }
  .dropdown-menu.show {
    padding: 0;
    top: -32px !important;
    left: -64px !important;
  }
  .dropdown-toggle {
    padding: 0px 10px;
  }
  .dropdown-toggle::after {
    content: url('@/assets/images/icons/more-details.svg');
    border: none;
  }
  .contact-person-email {
    min-width: 160px;
  }
  .fit-content {
    width: fit-content;
  }
  &__action {
    &__modal {
      padding-block: 83px;
      h3 {
        color: var(--color-17);
        font-size: 1.75rem;
        font-weight: 700;
        line-height: 32px;
      }
      h4 {
        color: var(--color-17);
        font-size: 1.125rem;
        line-height: 36px;
      }
    }
  }
  .delete-edit-model {
    background: var(--color-01);
    border: 1px solid var(--color-14);
    box-shadow: 0px 2px 3px var(--color-38);
    border-radius: 4px;
    .delete-edit-model-text {
      font-weight: 700;
      font-size: 12px;
      line-height: 24px;
      letter-spacing: -0.006em;
      color: var(--color-02);
    }
    .delete-edit-model-text:hover {
      background-color: var(--color-23);
      color: var(--color-01);
    }
    .label-text-filter {
      margin-bottom: 5px;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.4px;
      color: var(--color-76);
    }
    .assigned_vehicle {
      min-width: 100px;
    }
  }
  .table.b-table.b-table-no-border-collapse {
    border-spacing: 0px 16px !important;
  }
}
</style>
